import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { IconError } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { useCallback, useEffect, useState } from 'react';
import { NoticeWrapper } from '../../../../../../components/SearchForm/components/AirportsWidget/components/NoticeWrapper.js';
import { List } from '../../../../../../components/SearchForm/components/AirportsWidget/components/Suggestions/components/List/index.js';
import { useFilteredAirports } from '../../../../../../components/SearchForm/components/AirportsWidget/hooks/useFilteredAirports.js';
import { ClearIcon } from '../../../../../../components/SearchForm/components/ClearIcon.js';
import { LabelMediumBold, Notice, TextField } from '../../../../../../primitives/index.js';
export const Suggestions = ({
  nearbyAirports,
  onCheck,
  isChecked,
  onToggle,
  onInputChange
}) => {
  const {
    t
  } = useTranslation();
  const [inputValue, setInputValueState] = useState('');
  const {
    filteredAirports,
    noMatch
  } = useFilteredAirports(inputValue, nearbyAirports);
  const setInputValue = useCallback(value => {
    setInputValueState(value);
    onInputChange?.(value);
  }, [onInputChange]);
  useEffect(() => {
    onToggle(filteredAirports.length === 0);
  }, [filteredAirports]);
  const handleInputChange = e => {
    setInputValue(e.target.value);
  };
  const handleClearInput = () => {
    setInputValue('');
  };
  return _jsxs(_Fragment, {
    children: [_jsx(TextField, {
      placeholder: t(`airportsWidget:placeholder`),
      value: inputValue,
      onChange: handleInputChange,
      appendIcon: inputValue.length > 0 && _jsx(ClearIcon, {
        onClick: handleClearInput
      })
    }), noMatch && _jsx(Notice, {
      variant: "info",
      children: _jsxs(NoticeWrapper, {
        direction: "row",
        alignItems: 'center',
        children: [_jsx(IconError, {}), _jsx(LabelMediumBold, {
          children: t(`airportsWidget:errorMessage`)
        })]
      })
    }), _jsx(List, {
      value: inputValue,
      data: filteredAirports,
      isChecked: isChecked,
      onCheck: onCheck
    })]
  });
};